module.exports = __webpack_public_path__ + "static/media/BigDipper-LaCroixBoi.bd46db4e.jpg";